<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='16'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-button type="primary" size="mini" round plain @click="Createtask()">创建任务</el-button>
          <el-date-picker
            v-model="addtimeBTTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="selectOperationTime"
            size="small"
            style="margin-left: 50px;"
          >
          </el-date-picker>
          <!-- <div style="display: inline-block;padding-top:5px;padding-left:255px;">
            <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
          </div> -->
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" v-loading="qyloading" border style="width: 100%">
                  <el-table-column align="center" prop="name" label="姓名" width="150px"></el-table-column>
                  <el-table-column align="center" prop="job_content" label="工作内容" show-overflow-tooltip></el-table-column>
                  <el-table-column align="center" prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                  <el-table-column align="center" prop="date_time" label="日期" sortable width="150px"></el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="120px">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                      >
                        <p>确定删除该产品吗？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                      <el-button slot="reference" v-if="scopes.row.img" size="mini" type="text" @click="handleClick(scopes.row)">文件预览</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="日志信息" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="22">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="工作内容" prop="job_content">
              <el-input v-model="form.job_content" type="textarea" :rows="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="工作时间" required prop="date_time">
              <el-form-item>
                <el-date-picker type="date" placeholder="选择日期" v-model="form.date_time" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="上传文件" prop="img">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :on-remove="removeUpload"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx,.docx,.doc,.jpg,.pdf"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="false"
                :limit="1"
              >
                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="4" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveWorkdiary()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-image-viewer
      v-if="showImagePreview"
      :url-list="srcList"
      hide-on-click-modal
      teleported
      :on-close="closePreview"
      style="z-index: 3000"
    /> -->
    <el-image
      style="width: 0px; height: 0px"
      :src="url"
      :lazy="true"
      ref="preview"
      :preview-src-list="srcList">
    </el-image>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/workdiary'
import { getType, getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import vuelist from '@/utils/vue_list'

export default {
  name: 'Workdiary',
  components: { Top, LeftNav, Bottom, Pagination, ElImageViewer },
  mixins: [vuelist],
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      url: '',
      showImagePreview: false,
      qyloading: false,
      srcList: [],
      fileList: [],
      listQuery: {
        limit: 10,
        page: 1,
        order: 'date_time',
        is_delete: 1
      },
      dialogFormVisible: false,
      locktype: false,
      form: {
        job_content: '',
        date_time: '',
        remark: '',
        title: '',
        img: ''
      },
      rules: {
        job_content: [{ required: true, message: '请输入日志内容', trigger: 'blur' }],
        date_time: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      addtimeBTTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.LoadData()
  },
  methods: {
    Createtask () {
      this.dialogFormVisible = true
      this.form = {
        name: this.current_user.name,
        admin_id: this.current_user.id,
        job_content: '',
        date_time: '',
        remark: '',
        title: '',
        img: ''
      }
      this.form.title = ''
    },
    saveWorkdiary () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            return false
          }
          this.locktype = true
          api.saveWorkdiary(this.form).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.LoadData()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.form = Object.assign({}, row)
      this.form.img = row.title
      this.srcList = [row.img]
    },
    handlesuccess (response, file) {
      if (response.code === 20000) {
        this.form.img = response.message
        this.form.title = file.name
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、pdf格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6) && isLt2M
    },
    removeUpload (file, fileList) {
      this.form.img = file.response.message
      this.form.title = file.name
    },
    handleClick (row) {
      const thisType = getType(row.img)
      if (thisType === 'image') {
        this.srcList = [row.img]
        this.url = row.img
        this.$nextTick(() => {
          this.$refs.preview.clickHandler()
        })
      } else if (thisType === 'pdf') {
        window.open(row.img, '_target')
      } else {
        const url = 'http://view.officeapps.live.com/op/view.aspx?src=' + row.img
        window.open(url, '_target')
      }
    },
    // 关闭预览
    closePreview () {
      this.showImagePreview = false
      document.body.style.overflow = 'auto'
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.id }).then(response => {
        this.LoadData()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.preview.clickHandler()
      })
    },
    selectOperationTime () {
      this.listQuery.page = 1
      if (this.addtimeBTTime) {
        this.listQuery.operationBTTime = this.addtimeBTTime
      } else {
        this.listQuery.operationBTTime = []
      }
      this.LoadData()
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/member/workdiary.vue